// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAOF4OTpuRe4vqlGD_icnhmZXQQjeeM6vQ",
  databaseURL: "https://live-checker-7b277-default-rtdb.firebaseio.com",
};

// Initialize Firebase with a unique name "streamApp"
const app = initializeApp(firebaseConfig, "streamApp");
const database = getDatabase(app);

export { database };
